var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGhostOrange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 346,
    height: 338,
    viewBox: "0 0 346 338",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_220_25)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.26 172.488L91.0898 153.257C86.4449 147.784 87.1152 139.591 92.5724 134.938C95.025 132.856 98.0139 131.839 100.995 131.839C104.67 131.839 108.329 133.4 110.9 136.413L112.292 138.27",
    fill: "#FF9B05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.26 172.488L91.0898 153.257C86.4449 147.784 87.1152 139.591 92.5724 134.938C95.025 132.856 98.0139 131.839 100.995 131.839C104.67 131.839 108.329 133.4 110.9 136.413L112.292 138.27",
    stroke: "#CB37FF",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.507 168.475V192.205C220.507 198.695 223.086 204.925 227.676 209.507C232.565 214.396 239.308 216.999 246.216 216.652H256L247.884 224.837L231.627 236.201C219.545 244.017 205.484 248.417 191.092 248.307C187.054 248.267 182.993 247.904 178.979 247.203L169.271 245.515C161.487 244.151 154.035 241.572 147.158 237.881C140.281 234.198 133.98 229.427 128.531 223.702C115.456 209.98 108.169 191.763 108.169 172.812V165.652C108.169 123.879 133.326 90 164.342 90C186.305 90 205.334 106.987 214.561 131.757",
    fill: "#FF9B05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.507 168.475V192.205C220.507 198.695 223.086 204.925 227.676 209.507C232.565 214.396 239.308 216.999 246.216 216.652H256L247.884 224.837L231.627 236.201C219.545 244.017 205.484 248.417 191.092 248.307C187.054 248.267 182.993 247.904 178.979 247.203L169.271 245.515C161.487 244.151 154.035 241.572 147.158 237.881C140.281 234.198 133.98 229.427 128.531 223.702C115.456 209.98 108.169 191.763 108.169 172.812V165.652C108.169 123.879 133.326 90 164.342 90C186.305 90 205.334 106.987 214.561 131.757",
    stroke: "#CB37FF",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.553 152.41L210.312 138.629C215.369 133.528 223.597 133.492 228.69 138.548C233.791 143.605 233.82 151.832 228.771 156.926L212.958 174.473",
    fill: "#FF9B05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.553 152.41L210.312 138.629C215.369 133.528 223.597 133.492 228.69 138.548C233.791 143.605 233.82 151.832 228.771 156.926L212.958 174.473",
    stroke: "#CB37FF",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.429 154.553C137.532 154.553 140.858 147.901 140.858 139.696C140.858 131.49 137.532 124.838 133.429 124.838C129.326 124.838 126 131.49 126 139.696C126 147.901 129.326 154.553 133.429 154.553Z",
    fill: "#CB37FF",
    stroke: "#CB37FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.429 154.553C180.532 154.553 183.858 147.901 183.858 139.696C183.858 131.49 180.532 124.838 176.429 124.838C172.326 124.838 169 131.49 169 139.696C169 147.901 172.326 154.553 176.429 154.553Z",
    fill: "#CB37FF",
    stroke: "#CB37FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.213 195.256C158.853 195.256 163.425 184.865 163.425 172.047C163.425 159.229 158.853 148.838 153.213 148.838C147.572 148.838 143 159.229 143 172.047C143 184.865 147.572 195.256 153.213 195.256Z",
    fill: "#CB37FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_220_25",
    x: 0.0241394,
    y: 0.524139,
    width: 345.452,
    height: 337.26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 42.7379
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.79627 0 0 0 0 0.216423 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_220_25"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_220_25",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGhostOrange);
export default __webpack_public_path__ + "static/media/Ghost_Orange.8c38be28ed84281411b502596fff22f1.svg";
export { ForwardRef as ReactComponent };